let inject = ['$q','$http', 'ngAuthSettings', 'AuthTokenFactory', 'SharedService', 'SessionService'];
class DetailedPaymentService {
  constructor ($q, $http, ngAuthSettings, AuthTokenFactory, SharedService, SessionService) {
    this.$q = $q;
    this.$http = $http;
    this.ngAuthSettings = ngAuthSettings;
    this.AuthTokenFactory = AuthTokenFactory;
    this.SharedService = SharedService;
    this.SessionService = SessionService;
    this.payment = null;
  }
  
  getBillfold(documentNumber){
    return this.$q((resolve, reject) => {
      this.$http({
        method: 'GET',
        url: this.ngAuthSettings.apiServiceBaseUri + '/recaudos/recaudos/facturas-pendientes-co?terceroDocumento=' + documentNumber,
        cache : true
      }).then((response) => {
        resolve(response.data);
      }, (reason) => {
        reject(reason);
      });
    });
  }
  
  getItemsToFact(concept, documentNumber){
    return this.$q((resolve, reject) => {
      if(concept === 3) {
        this.$http({
          method: 'GET',
          url: this.ngAuthSettings.apiServiceBaseUri + '/recaudos/recaudos/pedidos-pendientes-co?terceroDocumento=' + documentNumber,
          cache : true
        }).then((response) => {
          resolve(response.data);
        }, (reason) => {
          reject(reason);
        });
      } else {
        this.$http({
          method: 'GET',
          url: this.ngAuthSettings.apiServiceBaseUri + '/recaudos/recaudos/facturas-pendientes-co?terceroDocumento=' + documentNumber,
          cache : true
        }).then((response) => {
          resolve(response.data);
        }, (reason) => {
          reject(reason);
        });
      }
    });
    
  }
  
  getPayment() {
    return this.payment;
  }
  
  setPayment(data) {
    this.payment = data;
  }
}

DetailedPaymentService.$inject = inject;

export default DetailedPaymentService;



/** WEBPACK FOOTER **
 ** C:/xampp/htdocs/payomaro-pay-zone/www/components/pay-zone/detailed-payment/detailed-payment.service.js
 **/